import React, { useState } from "react";

import "../StringTable/StringTable.css"
import "/src/assets/css/polices.css";
import countries from "./countries"

const CountryTable = ({ data,iconName }) => {

    const [isOpen, setOpen] = useState((false));

    const openListData = () => {
        setOpen(!isOpen);
    }

    const onSubmit = async (data) => {
    };

    return (
        <div className="data_container" onClick={() => openListData()}>
            {isOpen == false ?
               <span className={"flag-icon flag-icon-" + iconName} />
                :
                <span> {countries[iconName.toUpperCase()]} </span>
            }
        </div>
    )
};

export default CountryTable;